// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menuSearchOptionV2 {
    display: flex;
    position: relative;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    
  }
  .compactSelectorAdminV2 {
    position: relative;
    display: block;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
  
  }
  .react-select-container-admin-v2 {
    background: var(--white-color) !important;
    color: var(--main-color);
    outline: 0 !important;
   height: 100%;
  }
  /***************************** SELECTOR ADMIN **************************************/

.react-select-admin-v2__control{
    border-color: var(--border-table-color) !important;
    /* border-color: #ee085c; */
width: 100%;
height: 95% !important;
border-radius: 4px;
border-width: 2px !important;
background-color: var(--white-color) !important;
color: var(--txt-color) !important;

letter-spacing: 1px;
 text-align: left;
 min-height: unset !important;
 
 /* z-index: 999 !important; */
}
.react-select-admin-v2__input,.react-select-admin-v2__placeholder{
    background-color: transparent !important;
    color: var(--txt-color) !important;
    border: none !important;
    /* outline: 0 !important; */
    font-size: var(--font-size-small) !important;

}
.react-select-admin-v2__input{
height: 100% !important;
}
.react-select-admin-v2__input-container{
    height: 100%;
}
.react-select-admin-v2__input-container,.react-select-admin-v2__single-value {
    color: var(--txt-color) !important;
    text-align: center;
    font-size: var(--font-size-xSmall) !important;
    /* margin-bottom: 4px; */

}
.react-select-admin-v2__indicator svg{
    color: var(--txt-color) ;
 }


.react-select-admin-v2__menu:hover{
    cursor: pointer;
}
.react-select-admin-v2__menu{
    border-color:var(--main-color) !important;;
    background-color:var(--white-color)  !important ;
    color: var(--txt-color) !important;
    border: 1px solid aliceblue !important;
    align-items: center !important;
    display: flex !important;
    text-align: center !important;
    cursor: pointer;
    z-index: 999 !important;
    position: absolute !important;
    font-size: var(--font-size-small);
     /* overflow :auto; */
    /* overflow: hidden; */
    /* max-height:  100px !important;  */
}

.react-select-admin-v2__menu-list{
    width: 100% !important;
    /* height: 100% !important; */
    /* background-color: red; */
    /* overflow: unset !important; */
}
.react-select-admin-v2__option{
    border-bottom-color: rgba(255, 255, 255, 0.127) !important;
    width: 100% !important;
    color: var(--txt-color) !important;
}

/* .react-select-admin-v2__option:hover{
background-color: var(--hover-color) !important;
} */

.react-select-admin-v2__placeholder{
 color: var(--txt-color-low) !important;
 font-size: medium !important;
 /* margin-left:; */
}
  /***************Multi selector********************/
  .react-multi-select-admin-v2__option{
    border-bottom-color: rgba(255, 255, 255, 0.127) !important;
    width: 100% !important;
    color: var(--txt-color) !important;
    text-align: center;
}
.react-multi-select-admin-v2__control{
background-color: var(--white-color) !important;
}
.react-multi-select-admin-v2__input{
    color: var(--txt-color) !important;
    height: 100% !important;
    font-size: var(--font-size-small) !important;
}
.react-multi-select-admin-v2__input-container {
    height: 100%; 
}
.react-multi-select-admin-v2__multi-value{
    background-color: rgba(196, 196, 196, 0.192) !important;
    color: var(--red-alert) !important;
    border: 1px solid var(--border-table-color);
    border-radius: var(--border-radios-smal);
}
.react-multi-select-admin-v2__multi-value__label{
    color: var(--third-color) !important;
    font-size: var(--font-size-xSmall) !important;
    
}
/* **************************** horizontal Movil****************************** */
@media (min-width: 500px) and (max-width: 900px) {
    .react-select-container-admin-v2{
        /* top: 2%; */
    }
    .react-select-admin-v2__control{
        height: 20px !important;
    }
    .react-select-admin-v2__indicators{
        height: 20px !important;
    }
  }
  
  /* ****************************Movil****************************** */
  @media (max-width: 500px) {
    .react-select-container-admin-v2{
        /* top: 2%; */
    }
    .react-select-admin-v2__control{
        height: 20px !important;
    }
    .react-select-admin-v2__indicators{
        height: 20px !important;
    }
    /* .react-multi-select-container-admin-v2{
        top: 2%;
    }
    .react-multi-select-admin-v2__control{
        height: 20px !important;
    }
    .react-multi-select-admin-v2__indicators{
        height: 20px !important;
    } */
.contOptionRol{
    height: 88%;
}
  }`, "",{"version":3,"sources":["webpack://./src/components/generales/styles/SelectorForm.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;;EAEd;EACA;IACE,kBAAkB;IAClB,cAAc;IACd,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;;EAEd;EACA;IACE,yCAAyC;IACzC,wBAAwB;IACxB,qBAAqB;GACtB,YAAY;EACb;EACA,oFAAoF;;AAEtF;IACI,kDAAkD;IAClD,2BAA2B;AAC/B,WAAW;AACX,sBAAsB;AACtB,kBAAkB;AAClB,4BAA4B;AAC5B,+CAA+C;AAC/C,kCAAkC;;AAElC,mBAAmB;CAClB,gBAAgB;CAChB,4BAA4B;;CAE5B,6BAA6B;AAC9B;AACA;IACI,wCAAwC;IACxC,kCAAkC;IAClC,uBAAuB;IACvB,2BAA2B;IAC3B,4CAA4C;;AAEhD;AACA;AACA,uBAAuB;AACvB;AACA;IACI,YAAY;AAChB;AACA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,6CAA6C;IAC7C,wBAAwB;;AAE5B;AACA;IACI,wBAAwB;CAC3B;;;AAGD;IACI,eAAe;AACnB;AACA;IACI,yCAAyC;IACzC,gDAAgD;IAChD,kCAAkC;IAClC,sCAAsC;IACtC,8BAA8B;IAC9B,wBAAwB;IACxB,6BAA6B;IAC7B,eAAe;IACf,uBAAuB;IACvB,6BAA6B;IAC7B,iCAAiC;KAChC,oBAAoB;IACrB,sBAAsB;IACtB,oCAAoC;AACxC;;AAEA;IACI,sBAAsB;IACtB,6BAA6B;IAC7B,2BAA2B;IAC3B,gCAAgC;AACpC;AACA;IACI,0DAA0D;IAC1D,sBAAsB;IACtB,kCAAkC;AACtC;;AAEA;;GAEG;;AAEH;CACC,sCAAsC;CACtC,4BAA4B;CAC5B,kBAAkB;AACnB;EACE,kDAAkD;EAClD;IACE,0DAA0D;IAC1D,sBAAsB;IACtB,kCAAkC;IAClC,kBAAkB;AACtB;AACA;AACA,+CAA+C;AAC/C;AACA;IACI,kCAAkC;IAClC,uBAAuB;IACvB,4CAA4C;AAChD;AACA;IACI,YAAY;AAChB;AACA;IACI,uDAAuD;IACvD,kCAAkC;IAClC,2CAA2C;IAC3C,wCAAwC;AAC5C;AACA;IACI,oCAAoC;IACpC,6CAA6C;;AAEjD;AACA,gFAAgF;AAChF;IACI;QACI,aAAa;IACjB;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,uBAAuB;IAC3B;EACF;;EAEA,oEAAoE;EACpE;IACE;QACI,aAAa;IACjB;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,uBAAuB;IAC3B;IACA;;;;;;;;OAQG;AACP;IACI,WAAW;AACf;EACE","sourcesContent":[".menuSearchOptionV2 {\r\n    display: flex;\r\n    position: relative;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 100%;\r\n    height: 100%;\r\n    \r\n  }\r\n  .compactSelectorAdminV2 {\r\n    position: relative;\r\n    display: block;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 100%;\r\n    height: 100%;\r\n  \r\n  }\r\n  .react-select-container-admin-v2 {\r\n    background: var(--white-color) !important;\r\n    color: var(--main-color);\r\n    outline: 0 !important;\r\n   height: 100%;\r\n  }\r\n  /***************************** SELECTOR ADMIN **************************************/\r\n\r\n.react-select-admin-v2__control{\r\n    border-color: var(--border-table-color) !important;\r\n    /* border-color: #ee085c; */\r\nwidth: 100%;\r\nheight: 95% !important;\r\nborder-radius: 4px;\r\nborder-width: 2px !important;\r\nbackground-color: var(--white-color) !important;\r\ncolor: var(--txt-color) !important;\r\n\r\nletter-spacing: 1px;\r\n text-align: left;\r\n min-height: unset !important;\r\n \r\n /* z-index: 999 !important; */\r\n}\r\n.react-select-admin-v2__input,.react-select-admin-v2__placeholder{\r\n    background-color: transparent !important;\r\n    color: var(--txt-color) !important;\r\n    border: none !important;\r\n    /* outline: 0 !important; */\r\n    font-size: var(--font-size-small) !important;\r\n\r\n}\r\n.react-select-admin-v2__input{\r\nheight: 100% !important;\r\n}\r\n.react-select-admin-v2__input-container{\r\n    height: 100%;\r\n}\r\n.react-select-admin-v2__input-container,.react-select-admin-v2__single-value {\r\n    color: var(--txt-color) !important;\r\n    text-align: center;\r\n    font-size: var(--font-size-xSmall) !important;\r\n    /* margin-bottom: 4px; */\r\n\r\n}\r\n.react-select-admin-v2__indicator svg{\r\n    color: var(--txt-color) ;\r\n }\r\n\r\n\r\n.react-select-admin-v2__menu:hover{\r\n    cursor: pointer;\r\n}\r\n.react-select-admin-v2__menu{\r\n    border-color:var(--main-color) !important;;\r\n    background-color:var(--white-color)  !important ;\r\n    color: var(--txt-color) !important;\r\n    border: 1px solid aliceblue !important;\r\n    align-items: center !important;\r\n    display: flex !important;\r\n    text-align: center !important;\r\n    cursor: pointer;\r\n    z-index: 999 !important;\r\n    position: absolute !important;\r\n    font-size: var(--font-size-small);\r\n     /* overflow :auto; */\r\n    /* overflow: hidden; */\r\n    /* max-height:  100px !important;  */\r\n}\r\n\r\n.react-select-admin-v2__menu-list{\r\n    width: 100% !important;\r\n    /* height: 100% !important; */\r\n    /* background-color: red; */\r\n    /* overflow: unset !important; */\r\n}\r\n.react-select-admin-v2__option{\r\n    border-bottom-color: rgba(255, 255, 255, 0.127) !important;\r\n    width: 100% !important;\r\n    color: var(--txt-color) !important;\r\n}\r\n\r\n/* .react-select-admin-v2__option:hover{\r\nbackground-color: var(--hover-color) !important;\r\n} */\r\n\r\n.react-select-admin-v2__placeholder{\r\n color: var(--txt-color-low) !important;\r\n font-size: medium !important;\r\n /* margin-left:; */\r\n}\r\n  /***************Multi selector********************/\r\n  .react-multi-select-admin-v2__option{\r\n    border-bottom-color: rgba(255, 255, 255, 0.127) !important;\r\n    width: 100% !important;\r\n    color: var(--txt-color) !important;\r\n    text-align: center;\r\n}\r\n.react-multi-select-admin-v2__control{\r\nbackground-color: var(--white-color) !important;\r\n}\r\n.react-multi-select-admin-v2__input{\r\n    color: var(--txt-color) !important;\r\n    height: 100% !important;\r\n    font-size: var(--font-size-small) !important;\r\n}\r\n.react-multi-select-admin-v2__input-container {\r\n    height: 100%; \r\n}\r\n.react-multi-select-admin-v2__multi-value{\r\n    background-color: rgba(196, 196, 196, 0.192) !important;\r\n    color: var(--red-alert) !important;\r\n    border: 1px solid var(--border-table-color);\r\n    border-radius: var(--border-radios-smal);\r\n}\r\n.react-multi-select-admin-v2__multi-value__label{\r\n    color: var(--third-color) !important;\r\n    font-size: var(--font-size-xSmall) !important;\r\n    \r\n}\r\n/* **************************** horizontal Movil****************************** */\r\n@media (min-width: 500px) and (max-width: 900px) {\r\n    .react-select-container-admin-v2{\r\n        /* top: 2%; */\r\n    }\r\n    .react-select-admin-v2__control{\r\n        height: 20px !important;\r\n    }\r\n    .react-select-admin-v2__indicators{\r\n        height: 20px !important;\r\n    }\r\n  }\r\n  \r\n  /* ****************************Movil****************************** */\r\n  @media (max-width: 500px) {\r\n    .react-select-container-admin-v2{\r\n        /* top: 2%; */\r\n    }\r\n    .react-select-admin-v2__control{\r\n        height: 20px !important;\r\n    }\r\n    .react-select-admin-v2__indicators{\r\n        height: 20px !important;\r\n    }\r\n    /* .react-multi-select-container-admin-v2{\r\n        top: 2%;\r\n    }\r\n    .react-multi-select-admin-v2__control{\r\n        height: 20px !important;\r\n    }\r\n    .react-multi-select-admin-v2__indicators{\r\n        height: 20px !important;\r\n    } */\r\n.contOptionRol{\r\n    height: 88%;\r\n}\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
